/**
 * What a screen says when there is nothing on it — including what to do about that.
 *
 * Dashed, so it reads as an absence rather than as a card. The body always names the next step: "No
 * items" on its own is indistinguishable from a broken query, which is the failure this component
 * exists to avoid.
 */
import { Text } from '@/components/ui/text';
import * as React from 'react';
import { View } from 'react-native';

export function Empty({
  mark = '◇',
  title,
  body,
  action,
}: {
  mark?: string;
  title: string;
  body: string;
  action?: React.ReactNode;
}) {
  return (
    <View className="bg-card border-border items-center gap-3 rounded-lg border border-dashed px-6 py-12">
      <View className="bg-accent size-12 items-center justify-center rounded-lg">
        <Text className="text-accent-foreground text-[22px] leading-[26px]">{mark}</Text>
      </View>
      <Text variant="heading">{title}</Text>
      <Text className="text-muted-foreground max-w-[380px] text-center">{body}</Text>
      {action}
    </View>
  );
}
